import {useTranslation} from 'react-i18next';

import {reservationStatusLabel} from '../../../config/reservationTriggers';
import {getReservationStatusOptions} from '../../../../../reservations/reservationStatusOptions';
import {MultiSelect} from '../../../../../common/newSelect';

interface ReservationStatusMultiSelectFieldProps {
    label: string;
    value: string[];
    onChange: (values: string[]) => void;
    placeholder?: string;
    disabled?: boolean;
}

/** Statuses in lifecycle order, which the select keeps; its rows carry no colour dots (`common/newSelect/AGENTS.md`). */
const ReservationStatusMultiSelectField = (props: ReservationStatusMultiSelectFieldProps) => {
    const {t} = useTranslation();

    const options = getReservationStatusOptions(true, props.value).map(status => ({
        value: status,
        label: reservationStatusLabel(status, t)
    }));

    return <MultiSelect {...props} options={options}/>;
};

export default ReservationStatusMultiSelectField;
